// ADO #582 (4) — the legacy "New Variable" dialog (ResourceForms.jsx
// AddResourceForm) saves `type: 'ARRAY'` (upper case) and no `resourceType`,
// while every picker filters on the AddResourceModalV2 vocabulary
// (`resourceType: 'array_1d'`). `(r.resourceType || r.type).toLowerCase()` of
// the legacy one is 'array', which no filter lists, so an array made from the
// Assignment editor's own "New Variable" button was missing from that very
// Assignment's picker.
//
// Normalise at the door: a resource that arrives without a `resourceType`
// gets the canonical one derived from its legacy `type`. `type` is left as it
// was, so code that still reads the legacy field is unaffected.

const LEGACY_TO_CANONICAL = {
  variable: 'variable',
  constant: 'constant',
  formula: 'formula',
  array: 'array_1d',
  array_1d: 'array_1d',
  array_2d: 'array_2d',
};

export function canonicalResourceType(resource) {
  if (!resource) return '';
  const raw = String(resource.resourceType || resource.type || '').trim();
  const lower = raw.toLowerCase();
  return LEGACY_TO_CANONICAL[lower] || lower;
}

export function normalizeLegacyResource(resource) {
  if (!resource || typeof resource !== 'object') return resource;
  if (resource.resourceType) {
    const canon = canonicalResourceType(resource);
    return canon === resource.resourceType ? resource : { ...resource, resourceType: canon };
  }
  if (!resource.type) return resource;
  return { ...resource, resourceType: canonicalResourceType(resource) };
}
